var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56175 0C3.00896 0 0 3.14279 0 6.86496C0 10.7632 3.48779 14.7498 5.83375 17.5517C5.84296 17.5629 6.22213 18 6.68904 18H6.73021C7.19767 18 7.57413 17.5629 7.58333 17.5517C9.78467 14.9236 13 10.5894 13 6.86496C13 3.14222 10.653 0 6.56175 0ZM6.77896 16.7968C6.76 16.8165 6.73238 16.8384 6.708 16.857C6.68308 16.839 6.656 16.8165 6.63596 16.7968L6.35267 16.4581C4.12858 13.8087 1.08279 10.1799 1.08279 6.8644C1.08279 3.75255 3.59179 1.12391 6.56121 1.12391C10.2603 1.12391 11.9161 4.00681 11.9161 6.8644C11.9161 9.38111 10.1877 12.7236 6.77896 16.7968ZM6.51896 3.40604C4.72442 3.40604 3.26896 4.91697 3.26896 6.78115C3.26896 8.64533 4.72442 10.1563 6.51896 10.1563C8.3135 10.1563 9.76896 8.64477 9.76896 6.78115C9.76896 4.91753 8.31404 3.40604 6.51896 3.40604ZM6.51896 9.03122C5.32404 9.03122 4.32738 7.99731 4.32738 6.7564C4.32738 5.51548 5.29913 4.50633 6.49404 4.50633C7.6895 4.50633 8.66071 5.51548 8.66071 6.7564C8.66125 7.99731 7.71442 9.03122 6.51896 9.03122Z",
    fill: "#7A7B7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.4e44871857617cf1705a9162e08383ac.svg";
export { ForwardRef as ReactComponent };